import { render, staticRenderFns } from "./CategorySermon.vue?vue&type=template&id=65868338&"
import script from "./CategorySermon.vue?vue&type=script&lang=js&"
export * from "./CategorySermon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports